import React from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
	ShowMoreWrapper,
	RowsCountDataContainer,
	MoreLessBlockWrapper,
} from './styles';

export const ShowMoreComponent = ({
	shouldShowMore,
	showMoreData,
	showLessData,
	count,
	totalCount,
	showMoreHandler,
	showLessHandler,
}) => {
	return (
		<MoreLessBlockWrapper>
			<RowsCountDataContainer>
				{count < totalCount ? count : totalCount}/{totalCount}
			</RowsCountDataContainer>
			{shouldShowMore &&
				showMoreData && (
					<ShowMoreWrapper>
						<ApButtonLink
							onClick={e => {
								e.preventDefault();
								showMoreHandler();
							}}
						>
							Show more...
						</ApButtonLink>
					</ShowMoreWrapper>
				)}
			{shouldShowMore &&
				showLessData && (
					<ShowMoreWrapper>
						<ApButtonLink
							onClick={e => {
								e.preventDefault();
								showLessHandler();
							}}
						>
							Show less...
						</ApButtonLink>
					</ShowMoreWrapper>
				)}
		</MoreLessBlockWrapper>
	);
};
